import axiosInstanceNew from "../lib/axiosinstanceNew";

const SupportTickets = class {
  constructor() {
    this.baseUrl = "tickets";

    // Static data for support tickets
    this.staticData = [
      {
        _id: "1",
        id: "1",
        ticket_number: "TKT-001",
        subject: "Payment Issue",
        description: "Payment not received for last week's classes",
        status: "Open",
        priority: "High",
        category: "Payment",
        parent_id: null,
        created_by: {
          id: "101",
          name: "Rajesh Kumar",
          role: "Tutor",
        },
        assigned_to: "Support Team",
        created_at: "2024-01-10T08:00:00Z",
        updated_at: "2024-01-10T08:00:00Z",
      },
      {
        _id: "2",
        id: "2",
        ticket_number: "TKT-002",
        subject: "Login Problem",
        description: "Unable to login to the platform",
        status: "In Progress",
        priority: "Medium",
        category: "Technical",
        parent_id: null,
        created_by: {
          id: "102",
          name: "Priya Sharma",
          role: "Parent",
        },
        assigned_to: "Tech Support",
        created_at: "2024-01-12T08:00:00Z",
        updated_at: "2024-01-12T10:00:00Z",
      },
      {
        _id: "3",
        id: "3",
        ticket_number: "TKT-003",
        subject: "Class Cancellation",
        description: "Need to cancel today's class due to emergency",
        status: "Resolved",
        priority: "Low",
        category: "Scheduling",
        parent_id: null,
        created_by: {
          id: "103",
          name: "Amit Verma",
          role: "Tutor",
        },
        assigned_to: "Operations Team",
        created_at: "2024-01-15T08:00:00Z",
        updated_at: "2024-01-15T12:00:00Z",
        resolved_at: "2024-01-15T12:00:00Z",
      },
      {
        _id: "4",
        id: "4",
        ticket_number: "TKT-004",
        subject: "Video Quality Issues",
        description: "Poor video quality during online classes",
        status: "Open",
        priority: "Medium",
        category: "Technical",
        parent_id: null,
        created_by: {
          id: "104",
          name: "Sunita Gupta",
          role: "Parent",
        },
        assigned_to: "Tech Support",
        created_at: "2024-01-18T08:00:00Z",
        updated_at: "2024-01-18T08:00:00Z",
      },
      {
        _id: "5",
        id: "5",
        ticket_number: "TKT-005",
        subject: "Tutor Change Request",
        description: "Request to change tutor for mathematics subject",
        status: "In Progress",
        priority: "High",
        category: "Academic",
        parent_id: null,
        created_by: {
          id: "105",
          name: "Vikram Singh",
          role: "Parent",
        },
        assigned_to: "Academic Team",
        created_at: "2024-01-20T08:00:00Z",
        updated_at: "2024-01-20T14:00:00Z",
      },
    ];
  }

  async list(query = []) {
    return await axiosInstanceNew.get(
      `${this.baseUrl}?${new URLSearchParams(query)}`
    );
  }
  async listsid(id) {
    return await axiosInstanceNew.get(`${this.baseUrl}?parent_id=${id}`);
  }
  async Add(data = []) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`, data)).data;
  }
  async Mark(id, data = []) {
    return (await axiosInstanceNew.put(`tickets/${id}`, data)).data;
  }
  async Detail(id) {
    return (await axiosInstanceNew.get(`tickets/${id}`)).data;
  }
  async Edit(id, data = []) {
    return (await axiosInstanceNew.get(`tickets/${id}`, data)).data;
  }
};

export default new SupportTickets();
